/* src/app/core/shared/components/schedules-days-editor/schedules-days-editor.component.css */
.form-check-input,
input[type=checkbox] {
  cursor: pointer;
  accent-color: #388543;
}
.form-check-input:checked {
  background-color: #388543;
  border-color: #388543;
}
.form-check-input:focus {
  border-color: #43ad55;
  box-shadow: 0 0 0 0.18rem rgba(56, 133, 67, 0.18);
}
.working-hours-table input[type=checkbox],
.exceptions-table input[type=checkbox] {
  width: 16px;
  height: 16px;
}
/*# sourceMappingURL=schedules-days-editor.component.css.map */
